import _ from '@lodash';
import axios from 'axios';
import { createEntityAdapter, createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import apiEndpoints from 'app/constants/apiEndpoints';
import { userLoggedOut } from 'app/auth/store/userSlice';

const { CLOSING_EVENTS_PAY } = apiEndpoints;

export const payEvents = createAsyncThunk('closingEvents/events/payEvents', async payroll => {
  const response = await axios.post(CLOSING_EVENTS_PAY, { payroll });
  const data = await response.data;

  return data.id;
});

const eventPayrollsAdapter = createEntityAdapter({});

export const {
  selectAll: selectPayrollEvents,
  selectIds: selectPayrollEventIds,
  selectById: selectPayrollEventById
} = eventPayrollsAdapter.getSelectors(state => state.payrollPage.payroll);

const initialState = eventPayrollsAdapter.getInitialState({
  pickedEvents: [],
  paymentDialog: {
    props: {
      open: false
    },
    data: null
  },
  pickedPayDate: null,
  pickedPaidDateStart: null,
  pickedPaidDateEnd: null
});

const eventsPayrollSlice = createSlice({
  name: 'payroll',
  initialState,
  reducers: {
    toggleEvents: {
      reducer: (state, action) => {
        const currentPickedEvents = state.pickedEvents ? state.pickedEvents : [];
        const { toggle, payroll, payrolls } = action.payload;

        if (payroll) {
          if (toggle) {
            return {
              ...state,
              pickedEvents: [...currentPickedEvents, payroll]
            };
          }
          return {
            ...state,
            pickedEvents: currentPickedEvents.filter(aPayroll => aPayroll.id !== payroll.id)
          };
        }
        if (payrolls && toggle) {
          return {
            ...state,
            pickedEvents: payrolls
          };
        }
        return {
          ...state,
          pickedEvents: []
        };
      }
    },
    pickPayDate: (state, action) => {
      return {
        ...state,
        pickedPayDate: action.payload
      };
    },
    pickPaidDateStart: (state, action) => {
      return {
        ...state,
        pickedPaidDateStart: action.payload
      };
    },
    pickPaidDateEnd: (state, action) => {
      return {
        ...state,
        pickedPaidDateEnd: action.payload
      };
    },
    openPayEventDialog: {
      prepare: payDialogData => {
        const payload = {
          props: {
            open: true
          },
          data: {
            ...payDialogData
          }
        };
        return { payload };
      },
      reducer: (state, action) => {
        state.paymentDialog = action.payload;
      }
    },
    // eslint-disable-next-line no-unused-vars
    closePayEventDialog: (state, action) => {
      state.paymentDialog = {
        type: 'pay',
        props: {
          open: false
        },
        data: null
      };
    },
    clearStatus: state => {
      return {
        ...state,
        status: {}
      };
    },
    clearPayroll: () => initialState
  },
  extraReducers: {
    [payEvents.fulfilled]: state => {
      return {
        ...state,
        status: {
          savedSuccessfully: true
        }
      };
    },
    [payEvents.rejected]: state => {
      return {
        ...state,
        status: {
          serverError: true
        }
      };
    },
    [userLoggedOut]: () => initialState
  }
});

export const selectPaymentDialog = state => state.payrollPage.payroll.paymentDialog;
export const selectPickedPayDate = state => state.payrollPage.payroll.pickedPayDate;
export const selectPickedPaidDateStart = state => state.payrollPage.payroll.pickedPaidDateStart;
export const selectPickedPaidDateEnd = state => state.payrollPage.payroll.pickedPaidDateEnd;
export const selectPickedEvents = state => _.get(state, 'payrollPage.payroll.pickedEvents', []);

export const {
  toggleEvents,
  pickPayDate,
  pickPaidDateStart,
  pickPaidDateEnd,
  openPayEventDialog,
  closePayEventDialog,
  clearPickedEvents,
  clearStatus,
  clearPayroll
} = eventsPayrollSlice.actions;

export default eventsPayrollSlice.reducer;
